/* Common JS for all pages.  Run at the end of the page, and could be deferred!  (hence the extra tests on domready) */

/* global gsap */

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', main());
} else {
    main();
}

function main() {

    gsap.utils.toArray('.lazyload-effect').forEach((lazyLoadEffect) => {
        gsap.to(lazyLoadEffect, {
            scrollTrigger: {
                trigger: lazyLoadEffect,
                start: "start 90%",
                end: "end 100%",
                toggleActions: "play none none none",
            },
            opacity: 1,
            duration: 1.5,
        });
    });

    gsap.utils.toArray('.underline').forEach((underlineEffect) => {
        gsap.to(underlineEffect, {
            scrollTrigger: {
                trigger: underlineEffect,
                start: "start 90%",
                end: "end 100%",
                toggleActions: "play none none none",
            },
            width: "10rem",
            duration: 1.5,
        });
    });
}

